import script from "./z-foot.vue?vue&type=script&setup=true&lang=js"
export * from "./z-foot.vue?vue&type=script&setup=true&lang=js"

import "./z-foot.vue?vue&type=style&index=0&id=22f0e302&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f0e302"]])

export default __exports__